import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// 0 = empty, 1 = weak, 2 = medium, 3 = strong
export const computePasswordStrength = (pwd) => {
  if (!pwd) return 0;
  let score = 0;
  if (pwd.length >= 8) score++;
  if (pwd.length >= 12) score++;
  if (/[a-z]/.test(pwd) && /[A-Z]/.test(pwd)) score++;
  if (/\d/.test(pwd)) score++;
  if (/[^A-Za-z0-9]/.test(pwd)) score++;
  // Collapse into 3 buckets
  if (score <= 1) return 1;
  if (score <= 3) return 2;
  return 3;
};

export const PasswordStrength = ({ password }) => {
  const { t } = useTranslation();
  const strength = useMemo(() => computePasswordStrength(password), [password]);

  if (!password) return null;

  const config = {
    1: { label: t('auth.strengthWeak'), color: 'bg-danger', textColor: 'text-danger', bars: 1 },
    2: { label: t('auth.strengthMedium'), color: 'bg-warning', textColor: 'text-warning', bars: 2 },
    3: { label: t('auth.strengthStrong'), color: 'bg-success', textColor: 'text-success', bars: 3 }
  }[strength];

  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1" aria-hidden="true">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors duration-300 ${i <= config.bars ? config.color : 'bg-border'}`}
          />
        ))}
      </div>
      <p className={`text-xs mt-1 font-medium ${config.textColor}`} data-testid="password-strength-label">
        {config.label}
      </p>
    </div>
  );
};
